import e from "./index27.js";
import { getContainerQuery as t, isCqShorthand as n } from "./index29.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/breakpoints/breakpoints.js
var r = {
	xs: 0,
	sm: 600,
	md: 900,
	lg: 1200,
	xl: 1536
}, i = {
	keys: [
		"xs",
		"sm",
		"md",
		"lg",
		"xl"
	],
	up: (e) => `@media (min-width:${r[e]}px)`
}, a = { containerQueries: (e) => ({ up: (t) => {
	let n = typeof t == "number" ? t : r[t] || t;
	return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
} }) };
function o(e, o, s) {
	let c = e.theme || {};
	if (Array.isArray(o)) {
		let e = c.breakpoints || i;
		return o.reduce((t, n, r) => (t[e.up(e.keys[r])] = s(o[r]), t), {});
	}
	if (typeof o == "object") {
		let e = c.breakpoints || i;
		return Object.keys(o).reduce((i, l) => {
			if (n(e.keys, l)) {
				let e = t(c.containerQueries ? c : a, l);
				e && (i[e] = s(o[l], l));
			} else if (Object.keys(e.values || r).includes(l)) {
				let t = e.up(l);
				i[t] = s(o[l], l);
			} else {
				let e = l;
				i[e] = o[e];
			}
			return i;
		}, {});
	}
	return s(o);
}
function s(e = {}) {
	return e.keys?.reduce((t, n) => {
		let r = e.up(n);
		return t[r] = {}, t;
	}, {}) || {};
}
function c(e, t) {
	return e.reduce((e, t) => {
		let n = e[t];
		return (!n || Object.keys(n).length === 0) && delete e[t], e;
	}, t);
}
function l(t, ...n) {
	let r = s(t), i = [r, ...n].reduce((t, n) => e(t, n), {});
	return c(Object.keys(r), i);
}
function u(e, t) {
	if (typeof e != "object") return {};
	let n = {}, r = Object.keys(t);
	return Array.isArray(e) ? r.forEach((t, r) => {
		r < e.length && (n[t] = !0);
	}) : r.forEach((t) => {
		e[t] != null && (n[t] = !0);
	}), n;
}
function d({ values: e, breakpoints: t, base: n }) {
	let r = n || u(e, t), i = Object.keys(r);
	if (i.length === 0) return e;
	let a;
	return i.reduce((t, n, r) => (Array.isArray(e) ? (t[n] = e[r] == null ? e[a] : e[r], a = r) : typeof e == "object" ? (t[n] = e[n] == null ? e[a] : e[n], a = n) : t[n] = e, t), {});
}
//#endregion
export { s as createEmptyBreakpointObject, o as handleBreakpoints, l as mergeBreakpointsInOrder, c as removeUnusedBreakpoints, d as resolveBreakpointValues, r as values };

//# sourceMappingURL=index33.js.map